const env: any = window['__env'] || {};
export const environment = env;
